import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfOrderService } from 'src/database';
import api from '../../services/api';


export const useOrderServiceListController = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState(true);
	const [orderServiceData, setOrderServiceData] = useState<ModelOfOrderService[]>([]);

	const toast: any = useRef();

	const getOrderServices = () => {
		api.post('/list-services-order', { ORGAO: userAgencyId, STATUS: 0 })
			.then((response) => {
				setOrderServiceData(
					response.data.filter((item: any) => {
						return item.ORGAO === userAgencyId;
					})
				);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	const printClickOrderService = (OrderService: ModelOfOrderService) => {
		console.log(" ---->. aqui. : ,---- ", OrderService)
		api.post('/print-orderservice', {OrderService: OrderService})
			.then((response) => {
				
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});


	}

	const handleClickOrderService = (OrderService: ModelOfOrderService) => {
		console.log(" ---->. aqui. : ,---- ", OrderService)
		const produtos = OrderService.PRODUTOS.map((product: any) => {
			let conta = product.VALOR_PRODUTO * product.QUANTIDADE_PRODUTO;
			return { ...product, VALOR_PRODUTOBASE: product.VALOR_PRODUTO, VALOR_PRODUTO: Number(conta.toFixed(2)) };
		});

		const servicos = OrderService.SERVICOS.map((service: any) => {
			let conta = service.VALOR_SERVICO * service.QUANTIDADE_SERVICO;
			return { ...service, VALOR_SERVICOBASE: service.VALOR_SERVICO, VALOR_SERVICO: Number(conta.toFixed(2)) };
		});

		return { ...OrderService, PRODUTOS: produtos, SERVICOS: servicos };
	};

	useEffect(() => {
		getOrderServices();
	}, []);

	return {
		getOrderServiceListController: {
			orderServiceData,
			loading,
			toast,
		},
		handleOrderServiceListController: {
			handleClickOrderService,
			printClickOrderService,
		},
	};
};
